import { render, staticRenderFns } from "./uf_is_availability_market.vue?vue&type=template&id=08966c74&scoped=true"
import script from "./uf_is_availability_market.vue?vue&type=script&lang=js"
export * from "./uf_is_availability_market.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08966c74",
  null
  
)

export default component.exports